import t from "styled-components";
import o from "../Icons/Mastercard.js";
import n from "../Icons/Visa.js";
const p = t.div``, d = t(p)`
  margin-bottom: 23px;
`, g = t(p)`
  margin: 8px 0;
`, l = t(p)`
  display: flex;
  justify-content: space-between;
  max-width: 350px;
`, y = t(p)`
  margin-top: 2px;
  max-width: 166px;
  margin-left: 8px;
`, e = t(n)``, s = t(o)``, a = (i) => (r) => `
  opacity: ${r.cardType === i ? "1.0" : "0.3"};
`, f = t(p)`
  display: flex;
  align-self: flex-end;
  position: relative;
  top: -35px;
  margin-bottom: -22px;
  right: 8px;
  width: 80px;

  svg {
    opacity: 0.3;
    transition: opacity 0.2s ease-in;
  }

  ${e} {
    margin-right: 8px;
    ${a("VISA")}
  }

  ${s} {
    ${a("Mastercard")}
  }
`;
export {
  p as BaseWrapper,
  y as CvvWrapper,
  l as ExpiryWrapper,
  d as HeadingWrapper,
  f as IconWrapper,
  g as InputContainer,
  s as Mastercard,
  e as Visa
};
